export default "__VITE_ASSET__D_l7m84U__"